module.exports = __webpack_public_path__ + "img/MR.cdce92d0.svg";